import React from 'react';
import { SpendableCalculation } from '../types/app';
import './SpendableGrid.css';

interface SpendableGridProps {
  calculations: SpendableCalculation[];
}

export const SpendableGrid: React.FC<SpendableGridProps> = ({ calculations }) => {
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  const getSpendableClass = (amount: number): string => {
    if (amount < 0) return 'negative';
    if (amount < 50) return 'low';
    return 'positive';
  };

  if (calculations.length === 0) {
    return (
      <div className="spendable-grid">
        <p className="no-data">No budget data available for the configured categories.</p>
      </div>
    );
  }

  return (
    <div className="spendable-grid">
      <div className="grid-header">
        <div className="header-cell">Category</div>
        <div className="header-cell">Balance</div>
        <div className="header-cell">Future Expenses</div>
        <div className="header-cell">Spendable</div>
        <div className="header-cell">Days Left</div>
      </div>
      
      {calculations.map((calc) => (
        <div key={calc.categoryName} className="grid-row">
          <div className="cell category-name">{calc.categoryName}</div>
          <div className="cell balance">{formatCurrency(calc.balance)}</div>
          <div className="cell future-expenses">{formatCurrency(calc.futureTransactions)}</div>
          <div className={`cell spendable ${getSpendableClass(calc.spendableAmount)}`}>
            {formatCurrency(calc.spendableAmount)}
          </div>
          <div className="cell remaining-days">{calc.remainingDays}</div>
        </div>
      ))}
      
      <div className="grid-summary">
        <div className="summary-row">
          <div className="cell summary-label">Total</div>
          <div className="cell summary-value">
            {formatCurrency(calculations.reduce((sum, calc) => sum + calc.balance, 0))}
          </div>
          <div className="cell summary-value">
            {formatCurrency(calculations.reduce((sum, calc) => sum + calc.futureTransactions, 0))}
          </div>
          <div className={`cell summary-value ${getSpendableClass(
            calculations.reduce((sum, calc) => sum + calc.spendableAmount, 0)
          )}`}>
            {formatCurrency(calculations.reduce((sum, calc) => sum + calc.spendableAmount, 0))}
          </div>
          <div className="cell"></div>
        </div>
      </div>
    </div>
  );
};
